import { PoliticaYPrivacidadSelectorModalForm } from "./PoliticaYPrivacidadSelectorModalForm"

const PoliticaYPrivacidadSelectorFormWrapper = ({userData, onClose}: any) => {
    return (<PoliticaYPrivacidadSelectorModalForm userData={userData} onClose={()=>onClose()}/>)
}

export { PoliticaYPrivacidadSelectorFormWrapper }